import { render, staticRenderFns } from "./CurtainTile.vue?vue&type=template&id=4a2fc6aa&"
import script from "./CurtainTile.vue?vue&type=script&lang=js&"
export * from "./CurtainTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports